import React from "react";
import { Modal as MuiModal, Typography, Box, Grid, Divider } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Button from "../Button";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  maxWidth: 560,
  margin: "auto",
  borderRadius: 2,
};

export function ModalAviso({ open, onClose, title, modalText }) {
  const headerBg = "#FFF4E5";
  const headerBorder = "#FFB74D";
  const headerColor = "#8A4500";

  return (
    <MuiModal open={open} onClose={() => onClose(false)} aria-labelledby="modal-aviso-title" aria-describedby="modal-aviso-desc">
      <Box sx={modalStyle}>
        <Box sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          p: 2,
          borderRadius: 1,
          backgroundColor: headerBg,
          border: `1px solid ${headerBorder}`,
          color: headerColor,
          mb: 2,
        }}>
          <WarningAmberIcon sx={{ fontSize: 28 }} />
          <Typography id="modal-aviso-title" variant="h6" sx={{ fontWeight: 700 }}>
            {title ? title : "Importante"}
          </Typography>
        </Box>

        {modalText ? (
          (() => {
            const texto = String(modalText);
            const quebra = texto.indexOf("\n");
            if (quebra !== -1) {
              const primeiraLinha = texto.slice(0, quebra);
              const restante = texto.slice(quebra + 1);
              return (
                <>
                  <Typography id="modal-aviso-desc" variant="body1" sx={{ color: "black", fontWeight: 700 }}>
                    {primeiraLinha}
                  </Typography>
                  <Typography variant="body1" sx={{ color: "black", whiteSpace: "pre-line", mt: 1, mb: 2 }}>
                    {restante}
                  </Typography>
                </>
              );
            }
            return (
              <Typography id="modal-aviso-desc" variant="body1" sx={{ color: "black", whiteSpace: "pre-line", mb: 2 }}>
                {texto}
              </Typography>
            );
          })()
        ) : null}

        <Divider sx={{ mb: 2 }} />

        <Grid container justifyContent="flex-end">
          <Grid item>
            <Button variant="contained" onClick={() => onClose(false)}>
              ENTENDI
            </Button>
          </Grid>
        </Grid>
      </Box>
    </MuiModal>
  );
}